<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">新增公司名稱</h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="receiver" class="col-2 text-right fontType">
                    <span class="text-red">＊</span>名稱
                  </label>
                  <div class="col-4 d-flex flex-column">
                    <input
                      type="text"
                      id="companyName"
                      maxlength="40"
                      name="名稱"
                      placeholder="名稱"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('名稱') || isCompanyNameExist }"
                      v-model="form.companyName"
                      class="form-control"
                      @input="form.companyName = form.companyName.trim()"
                      @blur="form.companyName = form.companyName.trim()"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="companyShortName" class="col-2 text-right fontType">
                    <span class="text-red">＊</span>簡稱
                  </label>
                  <div class="col-4 d-flex flex-column">
                    <input
                      type="text"
                      id="companyShortName"
                      maxlength="10"
                      name="簡稱"
                      placeholder="簡稱"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('簡稱') || isCompanyShortNameExist }"
                      v-model="form.companyShortName"
                      class="form-control"
                      @input="form.companyShortName = form.companyShortName.trim()"
                      @blur="form.companyShortName = form.companyShortName.trim()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="doCancel" class="btn btn-default editbtn mr-3">取消</a>
            <a @click="doInsert" class="btn btn-primary editbtn">新增</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { insertCompanyData } from "@/service";
export default {
  name: "CompanyListAddModal",
  mixins: [commonMixin],
  data() {
    return {
      form: {
        companyName: "",
        companyShortName: "",
      },
      isCompanyNameExist: false,
      isCompanyShortNameExist: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    companyList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    doCancel() {
      this.$emit("close");
      this.$validator.reset();
      this.$toast.info({ title: "取消新增" });
    },
    doInsert() {
      //檢核
      this.isCompanyNameExist = false;
      this.isCompanyShortNameExist = false;
      this.$validator.validateAll().then((el) => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        this.companyList.forEach((item) => {
          if (item.companyName == this.form.companyName) {
            this.isCompanyNameExist = true;
            this.$toast.info({ title: "公司名稱已存在" });
          }

          if (item.companyShortName == this.form.companyShortName) {
            this.isCompanyShortNameExist = true;
            this.$toast.info({ title: "公司簡稱已存在" });
          }
        });
        if (this.isCompanyShortNameExist || this.isCompanyNameExist) {
          return;
        }
        //通過檢查
        insertCompanyData(this.$store.state.userInfo.id, this.form).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "新增成功" });
              this.$emit("close");
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );
      });
    },
    initData() {
      this.isCompanyNameExist = false;
      this.isCompanyShortNameExist = false;
      this.form.companyName = "";
      this.form.companyShortName = "";
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}

.editbtn {
  width: 120px;
  height: 40px;
}

.getbtn {
  width: 180px;
  height: 40px;
  margin-bottom: -10px;
}

.editbtnFont {
  width: 100px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.fontType {
  font-family: PingFangTC;
}
</style>
